if (!customElements.get('view-switcher')) {
  class ViewSwitcher extends HTMLElement {
    constructor() {
      super();
    }

    setViewAttributeValue(value) {
      const target = this.closest('[css-view]');

      if (!target) return;

      target.setAttribute('css-view', value);

      target
        .querySelectorAll('view-switcher')
        .forEach((element) =>
          element.classList.toggle(
            'is-active',
            value == element.getAttribute('data-view'),
          ),
        );
    }

    handleClick(event) {
      event.preventDefault();

      this.setViewAttributeValue(this.getAttribute('data-view'));

      localStorage.setItem('view-switcher', this.getAttribute('data-view'));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));

      const currentView = localStorage.getItem('view-switcher');

      if (!currentView) return;

      this.setViewAttributeValue(currentView);
    }
  }

  customElements.define('view-switcher', ViewSwitcher);
}
